module.exports = __webpack_public_path__ + "img/logo-primerodemayocalzado.4b60df5f.png";